import template from './subcontractor-details.html';
import controller from './subcontractor-details.controller';

let subcontractorDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default subcontractorDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontractor-details/subcontractor-details.component.js